import React from 'react'
import { Grid, Typography, Box } from "@material-ui/core";
import useStyles from "./styles";
import CZlogo from "./C-Zentrix-logo.webp";
import routeMobilelogo from "./RouteMobile-Logo.webp";
import rmlLogo from "./call-center-logo.webp";

export default function RmlLogin() {

    var classes = useStyles();

  return (
    <div style={{position: "relative"}} className={classes.logotypeContainer}>
    <Box sx={{ position: "absolute", top: '2%', padding: "0 50px 0 20px", width: "100%" }}>
      <Grid container style={{ justifyContent: "space-between" }}>
        <Grid item xs={4} container>
          <Box
            component="img"
            src={CZlogo}
            alt="Middle"
            sx={{ height: "50px" }}
          />
        </Grid>
        {/* Left image */}
        <Grid item xs={4} container>
          <Box
            component="img"
            src={routeMobilelogo}
            alt="Left"
            sx={{ height: "50px", marginLeft: '140px' }}
          />
        </Grid>
        {/* Middle image */}
      </Grid>
    </Box>
    <div className={classes.rmlLogoParent}>
      <img src={rmlLogo} alt="logo" className={classes.logotypeImage} />
    </div>
    <Typography className={classes.logotypeText}>
      Contact Center Solution
    </Typography>
    <hr className={classes.divider} />
    <Typography className={classes.logotypeSubText}>
      Powered by C-Zentrix
    </Typography>
  </div>
  )
}
